import * as axios from '../../helpers/axios'

export const fetchBuildings = () => {
    return axios.runGet('auth/visitor_control/get_buildings')
}
